import {createAsyncAction} from 'typesafe-actions';
import * as payloads from "../aiAgent/payloads";
import {ApiCreateTenantErrorResponse} from "../aiAgent/payloads";
import {APIErrorInterface} from "../../types";
import {AiAgentListRequest, AiAgentsResponse, SsoResponse, TenantResponse} from "../../types/AiAgent";

export const exchangeTokenWithInternalAdapter = createAsyncAction(
    'EXCHANGE_TOKEN_WITH_INTERNAL_ADAPTER',
    'EXCHANGE_TOKEN_WITH_INTERNAL_ADAPTER_SUCCESSED',
    'EXCHANGE_TOKEN_WITH_INTERNAL_ADAPTER_FAILED'
)<
    payloads.ExchangeTokenWithInternalAdapterPayload,
    payloads.ExchangeTokenWithInternalAdapterResponse,
    APIErrorInterface | undefined
>();


export const checkOrCreateTenant = createAsyncAction(
    'CHECK_OR_CREATE_TENANT',
    'CHECK_OR_CREATE_TENANT_SUCCESSED',
    'CHECK_OR_CREATE_TENANT_FAILED'
)<
    {createIfNotExists: boolean},
    TenantResponse,
    ApiCreateTenantErrorResponse
>();

export const checkTenant = createAsyncAction(
    'CHECK_TENANT',
    'CHECK_TENANT_SUCCESSED',
    'CHECK_TENANT_FAILED',
)<
    undefined,
    TenantResponse,
    ApiCreateTenantErrorResponse
>();

export const getAccessLink = createAsyncAction(
    'GET_ACCESS_LINK',
    'GET_ACCESS_LINK_SUCCESSED',
    'GET_ACCESS_LINK_FAILED'
)<
    undefined,
    SsoResponse,
    APIErrorInterface
>();

export const getAiAgentsList = createAsyncAction(
    'GET_AI_AGENTS_LIST',
    'GET_AI_AGENTS_LIST_SUCCESSED',
    'GET_AI_AGENTS_LIST_FAILED'
)<
    AiAgentListRequest,
    AiAgentsResponse,
    {error?:string}
>();
